<template>
  <SDialog
    id="auth-dialog"
    v-model:show-dialog="visible"
    :width="380"
    data-testid="dialog-auth"
    content-class="dialog--auth"
    sticky-close
    light
    :aria-close="$t('dialog.close.aria-label')"
  >
    <AppAuthentication
      v-model="visible"
      :demo="demo"
      :guest="guest"
      :auth="auth"
      :btn-color="btnColor"
      :subscription="subscription"
      :register="register"
      :register-btn="registerBtn"
      @authenticated="emits('authenticated')"
    />
  </SDialog>
</template>

<script lang="ts" setup>
import AppAuthentication from '~/components/auth/Authentication.vue'
import { useCartStore } from '~/stores/cart'
import { useRootStore } from '~/stores/root'
import {useSAuth} from "~/composables/auth";

interface Props {
  modelValue?: boolean,
  demo?: boolean,
  guest?: boolean,
  auth?: boolean,
  subscription?: boolean,
  register?: boolean,
  registerBtn?: boolean,
  btnColor?: string,
}
const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  demo: false,
  guest: false,
  auth: true,
  subscription: false,
  register: true,
  registerBtn: false,
  btnColor: 'primary'
})

const sAuth = useSAuth()
const cartStore = useCartStore()

const emits = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'authenticated'): void
}>()

const router = useRouter()

const visible = computed({
  get: () => props.modelValue,
  set: async (val) => {
    emits('update:modelValue', val)
    if (!val) {
      if (!sAuth.isAuthenticated.value && cartStore.isSharedCartMode) {
        await cartStore.exitSharedCart()
        router.push('/')
      }
    }
  }
})

const rootStore = useRootStore()
const closeDialog = async () => {
  if (rootStore.timeoutMenu) {
    await sAuth.logout()
  }
  visible.value = false
}

const route = useRoute()

watch(() => route.path, () => {
  closeDialog()
})

</script>

<style lang="scss">
// Non-scoped: dialog content-class renders in a VOverlay portal.
@layer app-trumps {
  .dialog--auth {
    background-color: white;
    z-index: 2147483641;
    max-height: calc(100vh - 108px);
    margin-top: 144px;
  }
}
</style>
